(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/module/assets/javascripts/helpers/logger.js') >= 0) return;  svs.modules.push('/components/core/module/assets/javascripts/helpers/logger.js'); "use strict";

var log = svs.core.log;
svs.core.module.helpers.logger = new log.Logger('core:module');
 })(window);